
import { useList, useDetail, useCreate, useUpdate, useDelete, useAction } from "@inmagik/react-crud"
import { Tavola, CoordsPayload } from "../types"
import { API_URL } from "../constants"

export function useTavoleList(params: Record<string, string> = {}) {
  return useList<Tavola>(`${API_URL}/admin/tavole`, {
    query: params,
  })
}

export function useTavola(id: number | undefined) {
  return useDetail<Tavola>(`${API_URL}/admin/tavole`, id?.toString())
}

export function useTavolaCreate() {
  return useCreate<Tavola>(`${API_URL}/admin/tavole`)
}

export function useTavolaUpdate() {
  return useUpdate<Tavola>(`${API_URL}/admin/tavole`)
}

export function useTavolaDelete() {
  return useDelete<Tavola>(`${API_URL}/admin/tavole`)
}


export function useUpdateDetailsCoords(id: number | undefined) {
  return useAction<Tavola, CoordsPayload[]>(`${API_URL}/admin/tavole/${id}/update-coords`, {
    method: "POST",
    responseType: "text",
  })
}

type DropCoordsPayload = {
 dettaglio: number
}

export function useDropDetailCoords(id: number | undefined) {
  return useAction<Tavola, DropCoordsPayload>(`${API_URL}/admin/tavole/${id}/drop-coords`, {
    method: "POST",
    responseType: "text",
  })
}